<template>
  <span>
    <div
      class="background-wallpaper"
      style="background-image: url(https://wallpapercave.com/wp/wp6896343.jpg)"
    ></div>
    <section class="spaced">
      <div class="container content spaced">
        <div class="column c12 text-center spaced">
          <h1>PODCAST</h1>
        </div>
        <div class="column c6 push-center">
          <p class="text-center">
            Welcome to Patronus Podcast, explore exhilarating soundscapes and beats from our artists and friends.
          </p>
          <p clas="text-center">
            If you would like to contribute to the series, feel free to contact us via the <strong><router-link to="submission"> Submission Page </router-link></strong>.
          </p>
        </div>
      </div>
    </section>
    <section class="spaced">
      <div class="container content flex">
        <iframe
          width="100%"
          height="800"
          scrolling="no"
          frameborder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1008506356&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=fakse&show_reposts=false&show_teaser=false&visual=false"
        ></iframe>
        <div
          style="
            font-size: 10px;
            color: #cccccc;
            line-break: anywhere;
            word-break: normal;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-family: Interstate, Lucida Grande, Lucida Sans Unicode,
              Lucida Sans, Garuda, Verdana, Tahoma, sans-serif;
            font-weight: 100;
          "
        >
          <a
            href="https://soundcloud.com/patronusrecords"
            title="Patronus Records"
            target="_blank"
            style="color: #cccccc; text-decoration: none"
            >Patronus Records</a
          >
          ·
          <a
            href="https://soundcloud.com/patronusrecords/sets/patronus-podcast"
            title="Patronus Podcast"
            target="_blank"
            style="color: #cccccc; text-decoration: none"
            >Patronus Podcast</a
          >
        </div>
      </div>
    </section>
  </span>
</template>

<script>
export default {
  title: 'Patronus Records - Podcasts',
  name: 'podcast'

}
</script>
<style scoped>
.artwork {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/pages/podcast.vue